import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrypto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCrypto"><Path d="M9 13.732V10.268L12 8.53604L15 10.268V13.732L12 15.464L9 13.732Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6.22666L7 9.11333V14.8867L12 17.7734L17 14.8867V9.11333L12 6.22666Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrypto;
